<script>
import BFields from "@components/bosons/b-fields";

import ASelectInput from "@components/atoms/a-select-input.vue";
import AText from "@components/atoms/a-text.vue";

export default {
  name: "MFieldRadio",
  mixins: [BFields],
  components: {
    ASelectInput,
    AText,
  },
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    values: {
      type: Array[Object],
    },
    modelValue: {
      default: "",
    },
    value: String,
  },
  methods: {
    updateInput(event) {
      this.$emit("change", event);
    },
  },
};
</script>

<template>
  <div class="m-fieldSelect flex flex-col">
    <a-text
      v-if="hasLabel"
      :for="`${name}_${_uid}`"
      :content="label"
      tag="label"
      class="mb-2"
    />
    <a-select-input
      :values="values"
      @input="updateInput"
      :modelValue="modelValue"
      :disabled="disabled"
      class="rounded-1/4 px-4 font-medium text-base leading-tall w-full"
      :class="{
        'placeholder-light-300 border border-solid border-light-300 hover:border-dark-0 outline-none focus:border-primary text-light-300 focus:text-dark-200':
          !error.status.$error && modelValue === '',
        'border border-solid border-error hover:border-error outline-none focus:border-error text-light-300':
          error.status.$error,
        ' border border-solid border-primary-0 hover:border-primary-0 outline-none focus:border-primary': modelValue,
      }"
    >
      <template #disabled-option>{{ placeholder }}</template>
      <!-- <template slot-scope="{ option }"> {{ option.text }} </template> -->
    </a-select-input>
    <a-text
      v-if="modelValue === '341'"
      content="Você precisa aprovar o Débito Automático junto ao Itaú."
      tag="span"
      class="mt-2 text-dark-200 font-bold"
    />
    <a-text
      v-if="error.status.$error"
      :content="filterErrors()[0].message"
      tag="span"
      class="mt-1 text-error"
    />
  </div>
</template>
